export default "__VITE_ASSET__B2DMN5tX__"